import { SwiperComponent } from 'swiper/angular';

import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MetaTagsService,
  MobileDetectService,
  RouterService,
  UserModel,
  UserService,
} from '@lib/gc-common';
import { environment } from '@libs/gc-common/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mip-profile-invitation',
  templateUrl: './profile-invitation.component.html',
  styleUrls: ['./profile-invitation.component.scss'],
})
export class ProfileInvitationComponent implements OnInit, OnDestroy {
  @ViewChild('swiper', {
    static: false,
  })
  swiper: SwiperComponent;

  profile: UserModel = null;
  slideIndex = 0;

  assetsPath = environment.assetsPath;

  config = {
    pagination: true,
    autoHeight: true,
    // allowTouchMove: false,
    /*navigation: {
		 nextEl: '.__button-next'
		 }*/
  };

  routerSubscription = null;

  isDesktop = false;

  constructor(
    private routerService: RouterService,
    private userService: UserService,
    private metaTagsService: MetaTagsService,
    private translate: TranslateService,
    private mobileDetect: MobileDetectService,
  ) {
    this.isDesktop = !this.mobileDetect.isMobile();
    this.routerSubscription = this.routerService.onRouteChange().subscribe(async (route) => {
      // console.log('profile-invitation.component->constructor(): route', route);

      try {
        this.profile = await this.userService.getUser(route.params.userId);
        // console.log('profile-invitation.component->constructor(): this.profile', this.profile);

        if (route.params.code !== this.profile.referralCode) {
          return this.routerService.navigateTo('/404');
        }

        this.translate
          .get(['profile.invite.invitation.title', 'profile.invite.invitation.page.description'], {
            name: this.profile.getName() || `@${this.profile.username}`,
          })
          .subscribe((translation) => {
            // console.log('profile-invitation.component->constructor(): translation', translation);

            this.metaTagsService.setMetaTags({
              title: translation['profile.invite.invitation.title'],
              description: translation['profile.invite.invitation.page.description'],
              image: this.profile.avatar.source,
            });
          });
      } catch (e) {
        console.error('profile-invitation.component->constructor(): ERROR', e);
      }
    });
  }

  async ngOnInit() {
    // console.log('profile-invitation.component->ngOnInit(): isAuthenticated()', this.userService.isAuthenticated());
    /*if (this.userService.isAuthenticated()) {
		 const userId = await this.routerService.getRouteParam('userId');
		 await this.routerService.navigateTo(`/${userId.indexOf('@') > -1 ? '' : '@'}${userId}`);
		 }*/
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  slidePrev() {
    this.swiper.swiperRef.slidePrev();
    this.slideIndex = 0;
  }

  slideNext() {
    this.swiper.swiperRef.slideNext();
    this.slideIndex = 1;
  }
}
